import React from "react";
import { Link } from "react-router-dom";

import imgAceros from "../img/tubo_redondo.JPG";
import imgMobiliario from "../img/mueble_banio.jpg";
import "../styles/inicioAceros.css";  

const InicioAceros = () => {
  return (
    <div className="inicio-container">

      <section className="split-section">

        <div
          className="split-side left-side"
          style={{ backgroundImage: `url(${imgAceros})` }}
        >
          <Link to="/aceros" className="overlay">
            <h1 className="title">Aceros y Metales</h1>
            <p className="description">
              Tuberías, perfiles, láminas, servicios de corte y más.
            </p>
            <button className="btn btn-blue">Explorar</button>
          </Link>
        </div>

        <div
          className="split-side right-side"
          style={{ backgroundImage: `url(${imgMobiliario})` }}
        >
          <Link to="/mobiliario" className="overlay overlay-blue">
            <h1 className="title">Mobiliario y Acabados</h1>
            <p className="description">
              Muebles de baño, puertas, gabinetes y soluciones interiores.
            </p>
            <button className="btn btn-orange">Explorar</button>
          </Link>
        </div>

      </section>

    </div>
  );
};

export default InicioAceros;
